import { Link } from 'react-router-dom';
import { Category } from '@/types/database';
import { 
  Palette, ChefHat, Music, Laptop, Dumbbell, Languages, 
  Camera, Briefcase, Home, Music2, PenTool, MoreHorizontal,
  LucideIcon, Scissors, DollarSign, Heart, Film, Megaphone, Dog, Trophy, Sprout, Car, Beer, Telescope
} from 'lucide-react';

// Category images
import cookingImage from '@/assets/category-cooking.webp';
import artImage from '@/assets/category-art.webp';
import musicImage from '@/assets/category-music.jpg';
import fitnessImage from '@/assets/category-fitness.jpg';
import techImage from '@/assets/category-tech.jpg';
import photographyImage from '@/assets/category-photography.jpg';
import languagesImage from '@/assets/category-languages.jpg';

const iconMap: Record<string, LucideIcon> = {
  Palette, ChefHat, Music, Laptop, Dumbbell, Languages,
  Camera, Briefcase, Home, Music2, PenTool, MoreHorizontal,
  Scissors, DollarSign, Heart, Film, Megaphone, Dog, Trophy, Sprout, Car, Beer, Telescope
};

const imageMap: Record<string, string> = {
  'cooking': cookingImage,
  'art': artImage,
  'music': musicImage,
  'fitness': fitnessImage,
  'tech': techImage,
  'photography': photographyImage,
  'languages': languagesImage,
  'wellness': fitnessImage,
  'dance': musicImage,
  'design': artImage,
};

interface CategoryCardProps {
  category: Category;
  variant?: 'default' | 'image';
}

export function CategoryCard({ category, variant = 'default' }: CategoryCardProps) {
  const IconComponent = iconMap[category.icon || 'MoreHorizontal'] || MoreHorizontal;
  const categoryImage = imageMap[category.slug];

  if (variant === 'image' && categoryImage) {
    return (
      <Link 
        to={`/browse?category=${category.slug}`}
        className="group relative aspect-[4/3] overflow-hidden rounded-xl"
      >
        <img 
          src={categoryImage} 
          alt={category.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/30 to-transparent" />
        <div className="absolute bottom-4 left-4 text-background">
          <h3 className="font-serif text-lg font-medium">{category.name}</h3>
        </div>
      </Link>
    );
  }

  return (
    <Link 
      to={`/browse?category=${category.slug}`}
      className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-card border hover:border-primary/50 hover:shadow-md transition-all duration-300"
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors">
        <IconComponent className="h-7 w-7 text-primary" />
      </div>
      <span className="text-sm font-medium text-center">{category.name}</span>
    </Link>
  );
}
